import { FormikField, P, theme } from '@ahmdigital/ui';
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { ErrorText } from '../../../step-input/styles';
import { FormValues } from '../../../../types';

const { colors, media, mediaQueries } = theme;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HelperTextP = styled(P)`
  color: ${colors.grey50};
  font-size: 14px;
`;
const LabelWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;
`;

const StyledFormikField = styled(FormikField)`
  margin-bottom: 0;
  width: 8rem;

  & > input {
    border-radius: 0.25rem;
    text-align: center;
  }

  @media (min-width: ${media.lg}) {
    width: 6.25rem;

    & > input {
      text-align: unset;
      text-indent: 1.25rem;
    }
  }
`;

const TravellersErrorText = styled(ErrorText)`
  ${mediaQueries.above(media.lg)} {
    bottom: unset;
    position: relative;
    margin-top: 0.25rem;
  }
`;

const TravellerFieldOuterWrapper = styled.div`
  margin-bottom: 1rem;
`;

type Props = {
  helperText?: string;
  id?: string;
  key?: number;
  labelText: string;
  name: string;
  required?: boolean;
};

const TravellerField = ({ id, key, labelText, helperText, name, required }: Props) => {
  const { errors, touched, values, setFieldValue } = useFormikContext<FormValues>();
  const currentFieldValue = values[name as keyof FormValues];

  // when a field is dynamic, using setFieldValue registers the value in the state
  useEffect(() => {
    if (!currentFieldValue) {
      setFieldValue(name, '');
    }
  }, []);
  const fieldError = errors[name as keyof FormValues];
  const isTouched = touched[name as keyof FormValues];
  return (
    <TravellerFieldOuterWrapper>
      <Wrapper key={key}>
        <LabelWrapper>
          <label id={`label-for-${id}`} htmlFor={name}>
            {`${required ? `${labelText}*` : `${labelText}`}`}
          </label>
          {helperText && <HelperTextP>{helperText}</HelperTextP>}
        </LabelWrapper>
        <StyledFormikField
          input={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          name={name}
          id={id}
          placeholder="Age"
          required={required}
          type="text"
          hideErrorMessage
        />
      </Wrapper>
      {fieldError && isTouched && <TravellersErrorText>{fieldError}</TravellersErrorText>}
    </TravellerFieldOuterWrapper>
  );
};

export default TravellerField;
